import axios from "axios";
import { getUserAccessToken } from "./Redux/actions/user";
// import Cookies from "universal-cookie";

const axios_instance = axios.create({
  baseURL: window._env.REACT_APP_EMCONSOLE_API_URL,
});

// const cookies = new Cookies();
// cookies.remove("__stripe_sid");
// cookies.remove("__stripe_mid");

axios_instance.interceptors.request.use((request) => requestHandler(request));

const requestHandler = async (request) => {
  // const cookies = new Cookies();
  // let stripe_sid = cookies.get("__stripe_sid");
  // let stripe_mid = cookies.get("__stripe_mid");

  let access_token = await getUserAccessToken();

  // let options = {
  //   headers: {
  //     stripe_mid: stripe_mid,
  //     stripe_sid: stripe_sid,
  //   },
  // };
  let {
    data: { csrfToken },
  } = await axios.get(
    `${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/csrftoken`,
  );

  request.headers = {
    Authorization: `Bearer ${access_token}`,
    csrfToken: csrfToken,
    // stripe_mid: stripe_mid,
    // stripe_sid: stripe_sid,
    "Content-Type": "application/json",
    "X-Frame-Options": "sameorigin",
    "strict-transport-security": "max-age=31536000; includeSubDomains",
    "Public-Key-Pins":'pin-sha256="AbCdEf123="; pin-sha256="ZyXwVu456=";max-age=2592000; includeSubDomains',
    "X-XSS-Protection": "1; mode=block",
    "X-Content-Type-Options": "nosniff",
    "X-Download-Options": "noopen",
    "Content-Security-Policy": "policy",
    ...request.headers,
  };
  return request;
};

export default axios_instance;
